import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import { analyticsTrack } from '../../analyticsUtils';
import InvoicesWalkthroughSequences from './InvoicesWalkthroughSequences';
import InvoicesWalkthroughFooter from './InvoicesWalkthroughFooter';
import './InvoicesWalkthrough.scss';
var InvoicesWalkthrough = /*#__PURE__*/function (_Component) {
  function InvoicesWalkthrough(props) {
    var _this;
    _classCallCheck(this, InvoicesWalkthrough);
    _this = _callSuper(this, InvoicesWalkthrough, [props]);
    _this.state = {
      showModal: false,
      sequence: 0
    };
    _this.setSequence = _this.setSequence.bind(_this);
    _this.openModal = _this.openModal.bind(_this);
    _this.closeModal = _this.closeModal.bind(_this);
    return _this;
  }
  _inherits(InvoicesWalkthrough, _Component);
  return _createClass(InvoicesWalkthrough, [{
    key: "setSequence",
    value: function setSequence(sequence) {
      this.setState({
        sequence: sequence
      });
    }
  }, {
    key: "openModal",
    value: function openModal() {
      var _this$props = this.props,
        userType = _this$props.userType,
        triggerText = _this$props.triggerText;
      this.setState({
        showModal: true
      }, function () {
        analyticsTrack("Clicked on ".concat(triggerText), {
          location: "".concat(userType, " Invoice Index")
        });
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        sequence = _this$state.sequence,
        showModal = _this$state.showModal;
      var _this$props2 = this.props,
        userType = _this$props2.userType,
        triggerText = _this$props2.triggerText,
        isButton = _this$props2.isButton;
      return /*#__PURE__*/React.createElement(Fragment, null, isButton ? /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary",
        onClick: this.openModal
      }, triggerText) : /*#__PURE__*/React.createElement("a", {
        className: "modal-anchor-trigger link",
        tabIndex: 0,
        role: "button",
        onClick: this.openModal
      }, triggerText), /*#__PURE__*/React.createElement(Modal, {
        id: "invoice-walkthrough",
        className: "style-guide",
        show: showModal,
        onHide: this.closeModal,
        size: "lg"
      }, /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
        className: "style-guide"
      }, /*#__PURE__*/React.createElement("div", {
        className: "walkthrough-container"
      }, /*#__PURE__*/React.createElement(InvoicesWalkthroughSequences, {
        type: userType,
        sequence: sequence,
        closeModal: this.closeModal
      }), /*#__PURE__*/React.createElement(InvoicesWalkthroughFooter, {
        type: userType,
        sequence: sequence,
        setSequence: this.setSequence,
        closeModal: this.closeModal
      }))))));
    }
  }]);
}(Component);
InvoicesWalkthrough.propTypes = {
  userType: PropTypes.string.isRequired,
  triggerText: PropTypes.string.isRequired,
  isButton: PropTypes.bool
};
InvoicesWalkthrough.defaultProps = {
  isButton: false
};
export default InvoicesWalkthrough;